import { createContext } from "react"

const MenuBarContext = createContext({
    layout: null, // Json string of menu items data from graphql
    menuItems: null, // All objects that belong to the menu bar e.g arts, emojis, stickers, etc
    activeMenu: null,  // The current active menu on the menu bar
    setActiveMenu: () => {}, // Set the active menu on the menu bar
    handleClick: () => {}, // Handler when a user clicks an menuitem
});

export default MenuBarContext;
